export const STEPS = {
  SALUTE: 0,
  COUNT_ON_ME: 1,
  I_AM_EVERYWHERE: 2,
};
